import { StockCountFilterValues } from "./types";

export const defaultStockCountsFilterValues: StockCountFilterValues = {
  locationId: [],
};

export const filterValuesToApiInput = (values: StockCountFilterValues) => {
  let v = {};
  if (values?.locationId?.length) {
    v = {
      ...v,
      locationId: {
        in: values.locationId,
      },
    };
  }

  return v;
};

export const SMALL_SCREEN_BREAKPOINT = 600;
